export const API = {
  ORIGIN: import.meta.env.MODE === 'production' ? '' : 'http://localhost:8001',
  AUTH: import.meta.env.MODE === 'production' ? 'https://api.jelled.ai/api/auth' : 'http://localhost:8001/api/auth',
  SSO: import.meta.env.MODE === 'production' ? 'https://api.jelled.ai/api/sso' : 'http://localhost:8001/api/sso',
}

export const STRIPE = {
  PAYMENT_URL:
    import.meta.env.MODE === 'production'
      ? 'https://buy.stripe.com/3csdSv97zeSVcSs3cf'
      : 'https://buy.stripe.com/test_28o3d50Ugc3Ic0MaEH',
  CUSTOMER_PORTAL:
    import.meta.env.MODE === 'production'
      ? 'https://billing.stripe.com/p/login/28oaEGdjs0LU1UI288'
      : 'https://billing.stripe.com/p/login/test_eVa9Eicvi2Et7BueUU',
}

export const APP_VERSION = 'https://app.jelled.ai/version.json'

export const LOCAL_STORAGE = {
  AUTH_TOKEN: 'jelled_jelled-token',
  ANONYMOUS_AUTH_TOKEN: 'jelled_anonymous-auth-token',
  ANONYMOUS_USER: 'jelled_anonymous-user',
  IMPERSONATING_AUTH_TOKEN: 'jelled_impersonating-token',
}

export const UI_SIZES = {
  NAV: {
    CONTAINER_WIDTH: 73,
  },
  TOP_PADDING: 32,
  ORG_INFO_BAR_HEIGHT: 40,
}

export const COLORS = {
  JELLED_MID_BLUE_10_PERCENT: '#E9F0FE',
  JELLED_LIGHT_BLUE: '#3A7AFF',
  JELLED_AQUA_BLUE: '#02BAF2',
  JELLED_PRIMARY_BLUE: '#2467F4',
  PURE_BLACK: '#000000',
  GRAY_0: '#222222',
  GRAY_1: '#383838',
  GRAY_2: '#666666',
  GRAY_3: '#999999',
  GRAY_4: '#BBBBBB',
  GRAY_5: '#DDDDDD',
  GRAY_6: '#EEEEEE',
  GRAY_7: '#F4F4F4',
  GRAY_8: '#F8F8F8',
  PURE_WHITE: '#ffffff',
  RED: '#FC4131',
  RED_HOVERED: '#d42213',
  ORANGE: '#FFA800',
  YELLOW: '#FFE200',
  YELLOW_GREEN: '#ADD853',
  GREEN: '#2BB04F',
  BLUE: '#2095F2',
  PURPLE: '#87079C',
  BROWN: '#B87A00',
  RED_10_PERCENT: '#FFECEA',
  ORANGE_10_PERCENT: '#FFF6E5',
  GREEN_10_PERCENT: '#EAF7ED',
  SPECIAL_STROKE: '#DEE5F3',
  SPECIAL_FILL: '#F0F5FE',
}
